(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('OrganoRelevante', OrganoRelevante);

    OrganoRelevante.$inject = ['$resource'];

    function OrganoRelevante ($resource) {
        var resourceUrl =  'api/organo-relevantes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'delete': {method:'DELETE'}
        });
    }
})();
